import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import InputForm, {
  AutoCompleteValue,
} from "../../../Components/InputForm/InputForm";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { RiFileListLine } from "react-icons/ri";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import moment from "moment";
import "../style.css";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";
import {
  getMemberSuretyDetailById,
  suretyDetailsApproval,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import BaseModal from "../../../Components/BaseModel/BaseModel";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { LoanStatus } from "../../../Helpers/Enums/ApplicationStatus";
import LoanModuleStatus, {
  iLoanModule,
} from "../../../Components/LoanModuleStatus/LoanModuleStatus";
import { decryptV2 } from "../../../Helpers/Cryptography/CryptoV2";
import { base64UrlDecode } from "../../../Helpers/Common";
import context from "react-bootstrap/esm/AccordionContext";
import { GenericMasterType, LoanTypeEnum } from "../../../Helpers/Enums/Enum";

const SuretyApproval = (props) => {
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const location = useLocation();
  const [isChecked, setIsChecked] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [confirmValue, setConfirmValue] = useState("");
  const [memberId, setMemberId] = useState("");
  const [isInvalidLink, setIsInvalidLink] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};

  const [data, setData] = useState<any>({
    MemberNo: "",
    TokenNo: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    ResidentialAddress: "",
    ContactNumber: "",
    EmailId: "",
    DateOfBirth: "",
    DateOfJoining: "",
    DateOfConfirmation: "",
    LoanAmount: "",
    RateOfInterest: "",
    LoanTenure: "",
    SurityId: 0,
    SuretyStatus: 0,
    LoanRequestId: 0,
    ALTLAmount: 0,
    LoanType: 0,
    AdditionalRateOfInterest:"",
  });

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("suretyid")) {
        const encLoanId = params.get("suretyid");
        getPersonalDetailsByIdApiCallll(encLoanId);
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (confirmValue) {
      ModalDesign();
    }
  }, [confirmValue]);

  const getPersonalDetailsByIdApiCallll = async (Id) => {
    showLoader();
    let requestParams = { EnMemberId: Id };
    const res = await APICall(getMemberSuretyDetailById, requestParams);
    // "Lrd_StatusId": 10,
    // "Lrs_StatusId": 35,

    if (res.Message === "Ok" && res.Data !== null) {
      if (res?.Data?.MemberId == context?.MemberId) {
        let data = {
          MemberNo: res.Data?.MemberNo,
          TokenNo: res.Data?.TokenNo,
          FirstName: res.Data?.FirstName,
          MiddleName: res.Data?.MiddleName,
          LastName: res.Data?.LastName,
          ResidentialAddress: res.Data?.ResidentialAddress,
          ContactNumber: res.Data?.MobileNumber,
          EmailId: res.Data?.EmailId,
          DateOfBirth: moment(res.Data?.DOB).isValid()
            ? moment(res.Data?.DOB).format(DATE_DISPLAY_FORMAT)
            : "",
          DateOfJoining: moment(res.Data?.DOJ).isValid()
            ? moment(res.Data?.DOJ).format(DATE_DISPLAY_FORMAT)
            : "",
          DateOfConfirmation: moment(res.Data?.DOC).isValid()
            ? moment(res.Data?.DOC).format(DATE_DISPLAY_FORMAT)
            : "",
          LoanAmount: res.Data?.Lrd_LoanAmount,
          RateOfInterest: res.Data?.RateOfInterest,
          LoanTenure: res.Data?.Lrd_InstallmentPeriod,
          SuretyStatus: res.Data?.Lrs_StatusId,
          SurityId: res.Data?.Lrs_SurityId,
          LoanRequestId: res.Data?.Lrd_Id,
          ALTLAmount: res.Data?.ALTLAmount,
          LoanType: res.Data?.Lrd_LoanType,
          AdditionalRateOfInterest : res.Data?.AdditionalRateOfInterest,
        };
        setData(data);
      } else {
        setData({
          ...data,
          SuretyStatus: LoanStatus.LoanModule_InvalidSuretyLink,
        });
      }

      hideLoader();
    } else {
      notify(ToastType.Error, "Data not found");
      hideLoader();
    }
  };

  const handleClick = async () => {
    showLoader();
    setFormErrors({});

    let Status = LoanStatus.LoanModule_SuretyRejectedByMember;
    if (confirmValue === "YES") {
      Status = LoanStatus.LoanModule_SuretyAcceptedByMember;
    }

    let param = {
      Id: data.SurityId,
      MemberNumber: data.MemberNo,
      LoanRequestId: data.LoanRequestId,
      StatusId: Status,
    };
   
    const insertData = await APICall(suretyDetailsApproval, param);

    if (insertData?.Status == ApiStatus.OK) {
      if (Status == LoanStatus.LoanModule_SuretyAcceptedByMember) {
        notify(ToastType.Success, "Surety successfully approved");
      } else {
        notify(ToastType.Success, "Surety successfully rejected");
      }
      setData({ ...data, SuretyStatus: Status });
    } else {
      notify(ToastType.Error, insertData?.Data?.Data);
    }

    hideLoader();
    // confirmValue
    handleCloseModal();
  };

  const onSubmitValidation = async () => {
    setFormErrors({});
    formErrorObj = {};

    if (!isChecked) {
      formErrorObj["checked_isEmpty"] = "Please select acceptance";
    }

    setFormErrors(formErrorObj);
  };

  const handleCheckboxChange = () => {
    setFormErrors({});
    setIsChecked(!isChecked);
  };

  const handleCloseModal = async (value = "NO") => {
    setConfirmValue(value);

    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (value == "NO") {
      isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
    } else if (isEmpty === true && value == "YES") {
      isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
    }
  };

  const ModalDesign = () => {
    return (
      <>
        <div className={"ModalSize"}>
          <label
            className="d-block"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontFamily: "var(--bs-body-font-family)",
              fontSize: "var(--bs-body-font-size)",
            }}
          >
            {confirmValue == "YES"
              ? "Do you wish to mark yourself as surety?"
              : "Reject yourself as surety."}
          </label>

          <div className="row justify-content-end no-gutters">
            <div className="col-auto">
              <button
                onClick={() => {
                  setModalOpen(false);
                }}
                className="btn btn-secondary btn-sm mx-2"
              >
                Cancel
              </button>
            </div>
            <div className="col-auto">
              <button
                onClick={handleClick}
                id={"saveBtn"}
                className="btn btn-secondary btn-sm"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  if (data?.SuretyStatus === LoanStatus.LoanModule_InvalidSuretyLink) {
    return (
      <LoanModuleStatus
        statusId={LoanStatus.LoanModule_InvalidSuretyLink}
        LoanModule={iLoanModule.Surity}
      />
    );
  }

  return (
    <>
      <LoanModuleStatus
        statusId={data?.SurityStaus}
        LoanModule={iLoanModule.Surity}
      />
      <div className="col-lg-12 col-md-12">
        <div
          className="row"
          style={{ marginLeft: "-30px", marginRight: "-30px" }}
        >
          <div className="col-lg-2 col-sm-2 col-xs-2"></div>
          <div
            className="col-lg-4 col-sm-4 col-xs-4"
            style={{ textAlign: "center" }}
          >
            Member No. <span style={{ fontWeight: 600 }}>{data?.MemberNo}</span>
          </div>
          <div
            className="col-lg-4 col-sm-4 col-xs-4"
            style={{ textAlign: "center" }}
          >
            Token No. <span style={{ fontWeight: 600 }}>{data?.TokenNo}</span>
          </div>
          <div className="col-lg-2 col-sm-2 col-xs-2"></div>
        </div>
      </div>

      <div className="mx-3" style={{ padding: "20px 0 0 0" }}>
        <div className="col-lg-12 col-md-12 mt-3">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>First Name</label>
                <InputForm
                  placeholder={""}
                  value={data?.FirstName}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Middle Name</label>
                <InputForm
                  placeholder={""}
                  value={data?.MiddleName}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Last Name</label>
                <InputForm
                  placeholder={""}
                  value={data?.LastName}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12 col-md-12 mt-3">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Residential Address</label>
                <InputForm
                  placeholder={""}
                  value={data?.ResidentialAddress}
                  type="text"
                  textArea={true}
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Contact Number</label>
                <InputForm
                  placeholder={""}
                  value={data?.ContactNumber}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Email Id</label>
                <InputForm
                  placeholder={""}
                  value={data?.EmailId}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-md-12 mt-3">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Date of Birth</label>
                <InputForm
                  placeholder={""}
                  value={data?.DateOfBirth}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Date of Joining</label>
                <InputForm
                  placeholder={""}
                  value={data?.DateOfJoining}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Date of Confirmation</label>
                <InputForm
                  placeholder={""}
                  value={data?.DateOfConfirmation}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-md-12 mt-3">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
              <label>
                {data?.LoanType === LoanTypeEnum.LONGTERM
                  ? "Long Term Loan Amount"
                  : "Short Term Loan Amount"}
              </label>
                {/* <label>Loan Amount</label> */}
                <InputForm
                  placeholder={""}
                  value={data?.LoanAmount?.toLocaleString("en-IN")}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Long term loan Interest rate</label>
                <InputForm
                  placeholder={""}
                  value={data?.RateOfInterest + " %"}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Loan Tenure</label>
                <InputForm
                  placeholder={""}
                  value={data?.LoanTenure + " Months"}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>
        {data?.LoanType == LoanTypeEnum.LONGTERM && (
          <div className="col-lg-12 col-md-12 mt-3">
            <div className="row">
              <div className="col-lg-4 col-sm-4 col-xs-4">
                <div className="form-group">
                  <label>Additional Long Term Loan Amount</label>
                  <InputForm
                    placeholder={""}
                    value={data?.ALTLAmount?.toLocaleString("en-IN")}
                    type="text"
                    isDisabled={true}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Additional long term loan Interest rate</label>
                <InputForm
                placeholder={""}
                  value={data?.AdditionalRateOfInterest + " %"}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            </div>
          </div>

          
        )}
      </div>
      {LoanStatus.LoanModule_SuretyApprovalPending == data?.SuretyStatus && (
        <>
          <div className="col-lg-12 col-md-12 mt-3">
            <div className="row">
              <div
                className="col-lg-12 col-md-12 mt-3"
                style={{ marginLeft: "15px" }}
              >
                <div>
                  <input
                    autoComplete={AutoCompleteValue}
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <span style={{ padding: "0 0px 0px 10px" }}>
                    In the event of loan being granted, we hereby agree to be
                    sureties and shall be jointly and severally responsible
                    liable for the outstanding dues
                  </span>
                  <p style={{ color: "red" }}>
                    {confirmValue == "YES" && formErrors["checked_isEmpty"]}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <div>
              <ButtonForm
                className="mx-2"
                id="cancel"
                value="No"
                onClick={() => {
                  handleCloseModal("NO");
                }}
              />
              <ButtonComponent
                icon={"RiFileListLine"}
                value="Yes"
                style={{ marginLeft: "10px" }}
                id={"saveBtn"}
                onClick={() => {
                  handleCloseModal("YES");
                }}
              >
                <RiFileListLine />
              </ButtonComponent>
            </div>
          </div>
        </>
      )}

      <BaseModal
        buttonText={""}
        open={isModalOpen}
        content={<ModalDesign />}
        onclose={handleCloseModal}
      />
    </>
  );
};

export default SuretyApproval;

